// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configure-grid-3 tr th:nth-child(-n+3), .configure-grid-3 tr td:nth-child(-n+3) {
  width: 38%;
  padding: 10px 0 10px 10px;
}

.configure-grid-3 tr th:first-child, .configure-grid-3 tr td:first-child {
  width: 24%;
}

.form-check-input[type=radio]:checked + label, .form-check-input[type=radio]:not(:checked) + label {
  padding-left: 0 !important;
}

.form-check {
  padding-right: 11px !important;
}

@media (max-width: 1199.98px) {
  .configure-grid-3 tr th:nth-child(-n+3), .configure-grid-3 tr td:nth-child(-n+3) {
    width: 40%;
  }
  .configure-grid-3 tr th:first-child, .configure-grid-3 tr td:first-child {
    width: 20%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/administration/policy-configurator/configure-screens-modal/configure-screens-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,yBAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,0BAAA;AAGJ;;AADA;EACE,8BAAA;AAIF;;AADA;EAEE;IACE,UAAA;EAGF;EADA;IACE,UAAA;EAGF;AACF","sourcesContent":[".configure-grid-3 tr th:nth-child(-n+3),.configure-grid-3 tr td:nth-child(-n+3){\r\n    width: 38%;\r\n    padding: 10px 0 10px 10px;\r\n}\r\n.configure-grid-3 tr th:first-child,.configure-grid-3 tr td:first-child{\r\n    width: 24%;\r\n}\r\n.form-check-input[type=radio]:checked + label,.form-check-input[type=radio]:not(:checked) + label{\r\n    padding-left: 0 !important;\r\n}\r\n.form-check{\r\n  padding-right: 11px !important;\r\n}\r\n\r\n@media (max-width: 1199.98px) { \r\n  \r\n  .configure-grid-3 tr th:nth-child(-n+3), .configure-grid-3 tr td:nth-child(-n+3) {\r\n    width: 40%;\r\n  }\r\n  .configure-grid-3 tr th:first-child, .configure-grid-3 tr td:first-child {\r\n    width: 20%;\r\n  }\r\n  \r\n  \r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
